// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import MainframeApp from './MainframeApp'
import Axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import Upload from '@/components/plex/Upload'
import Welcome from '@/components/Welcome'
import Stepper from '@/components/mainframe/Stepper'
import './assets/customcomp.css'

Vue.prototype.$http = Axios
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.config.productionTip = false
Vue.component('Welcome', Welcome)
Vue.component('Upload', Upload)
Vue.component('Stepper', Stepper)

new Vue({
  el: '#app',
  components: { App: window.location.hash === '#mainframe' ? MainframeApp : App },
  vuetify,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js